import ClinicianPublicHold from "@/components/marketing/ClinicianPublicHold";

const CliniciansDataHandling = () => (
  <ClinicianPublicHold
    eyebrow="Data-handling review"
    title="Production data-handling facts are not yet published here."
    description="Processor, subprocessor, region, authentication, row-level authorization, encryption, retention, backup, export, deletion, incident, and agreement statements remain under evidence review. This route collects no information and makes no production assurance."
  />
);

export default CliniciansDataHandling;
